import {colors} from "./Colors"
import {uiRadius} from "./uiTokens"

export const customTheme = (theme: "light" | "dark") => ({
    token: {
        fontFamily: "'Averta Demo PE Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n" +
            "'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n" +
            "sans-serif",
        colorLink: colors[theme].colorLink,
        colorInfo: colors[theme].colorPrimary,
        colorPrimary: colors[theme].colorPrimary,
        borderRadius: uiRadius.md,
        colorBgLayout: colors[theme].bgSecondaryPrimary,
        colorBgContainer: colors[theme].bgContainerColor,
        colorBgElevated: colors[theme].bgContainerColor,
        colorBorder: colors[theme].colorBorder,
        colorSplit: colors[theme].colorBorder,
        colorTextSecondary: theme === "dark" ? "rgba(196, 213, 236, 0.76)" : "#64748B",
        colorFillSecondary: theme === "dark" ? "rgba(148, 163, 184, 0.16)" : "rgba(15, 23, 42, 0.06)",
        colorFillTertiary: theme === "dark" ? "rgba(148, 163, 184, 0.12)" : "rgba(15, 23, 42, 0.04)",
        colorFillQuaternary: theme === "dark" ? "rgba(148, 163, 184, 0.08)" : "rgba(15, 23, 42, 0.025)",
        colorSuccess: "#16A34A",
        colorWarning: "#D97706",
        colorError: "#DC2626",
        colorInfoBg: theme === "dark" ? "rgba(144, 93, 255, 0.16)" : "rgba(144, 93, 255, 0.09)",
        fontSize: 14,
        fontSizeSM: 12,
        borderRadiusLG: uiRadius.md,
        borderRadiusSM: uiRadius.sm,
        controlHeight: 36,
        controlHeightSM: 30,
        controlHeightLG: 40,
        lineWidth: 1,
        boxShadow: "0 1px 0 rgba(15, 23, 42, 0.08)",
        boxShadowSecondary: "0 12px 36px rgba(15, 23, 42, 0.12)"
    }
})
